module.exports = __webpack_public_path__ + "static/img/bg.7577231c.png";